module.exports = __webpack_public_path__ + "img/background044.jpg";